import { useLanguage } from "@/components/sybrax/LanguageProvider";

const LanguageToggle = ({ className = "" }) => {
    const { lang, setLang } = useLanguage();

    const base =
        "px-3 py-1.5 text-xs font-semibold rounded-full transition-all duration-200";
    const active = "bg-cyan-500 text-[#030712] shadow-[0_0_14px_rgba(6,182,212,0.4)]";
    const inactive =
        "text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white";

    return (
        <div
            data-testid="lang-toggle"
            className={
                "inline-flex items-center rounded-full border border-slate-300/70 dark:border-white/10 " +
                "bg-white/70 dark:bg-white/[0.04] backdrop-blur-md p-0.5 " +
                className
            }
            role="group"
            aria-label="Language selector"
        >
            <button
                type="button"
                data-testid="lang-en"
                onClick={() => setLang("en")}
                aria-pressed={lang === "en"}
                className={`${base} ${lang === "en" ? active : inactive}`}
            >
                EN
            </button>
            <button
                type="button"
                data-testid="lang-tr"
                onClick={() => setLang("tr")}
                aria-pressed={lang === "tr"}
                className={`${base} ${lang === "tr" ? active : inactive}`}
            >
                TR
            </button>
        </div>
    );
};

export default LanguageToggle;
